import { render, staticRenderFns } from "./ProjectTaskView.vue?vue&type=template&id=277a9ac7"
import script from "./ProjectTaskView.vue?vue&type=script&lang=js"
export * from "./ProjectTaskView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports